export const QUESTION_TYPES = ['logical', 'mathematical', 'pattern', 'spatial', 'verbal'];
export const VOCAB_QUESTION_TYPES = ['synonym', 'reasoning', 'intelligence', 'antonym', 'pattern'];
